import React from 'react';
import { motion } from 'framer-motion';
import './ProcessingLoader.css';

const ProcessingLoader = ({ 
  message = "Processing your image...",
  subMessage = "This may take a few seconds"
}) => {
  return (
    <div className="processing-loader">
      <div className="loader-content">
        <div className="loader-animation">
          <motion.div 
            className="loader-circle outer"
            animate={{ rotate: 360 }}
            transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
          />
          <motion.div 
            className="loader-circle middle"
            animate={{ rotate: -360 }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          />
          <motion.div 
            className="loader-circle inner"
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
          />
          <div className="loader-icon">🥥</div>
        </div>
        
        <motion.h3 
          className="loader-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          {message}
        </motion.h3>
        
        <motion.p 
          className="loader-submessage"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          {subMessage}
        </motion.p>

        <div className="loader-dots">
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              className="loader-dot"
              animate={{ y: [0, -10, 0] }}
              transition={{ 
                duration: 0.6, 
                repeat: Infinity, 
                delay: i * 0.2,
                ease: "easeInOut"
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProcessingLoader;
